import React from 'react';
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';

import Arrow from '../arrow/Arrow';
import Icon from '../icon/Icon';
import Tags from '../tags/Tags';

interface IOwnProps {
    isPadded?: boolean;
    hasArrow?: boolean;
    link?: string;
    startTime?: string;
    imageUrl?: string | null;
    article?: string;
    preheader?: string;
    tags?: React.ReactNode | null;
    information?: React.ReactNode | null;
}

type Props = IOwnProps;

class ActivityListItem extends React.Component<Props, {}> {
    public render() {
        return <li className={'activity-list__item'.cAppend(this.props.isPadded, 'activity-list__item--padded')}>
            {this.props.link ?
                <Link to={this.props.link} className="activity-list__link">{this.getItemContent}</Link>
                :
                <div className="activity-list__link">{this.getItemContent}</div>
            }
            {this.props.preheader &&
                <React.Fragment>
                    {this.props.link ?
                        <Link to={this.props.link} className="activity-list__item__article article article--no-initial">
                            <div dangerouslySetInnerHTML={{ __html: this.renderPreheader }} />
                        </Link>
                        :
                        <div className="activity-list__item__article article article--no-initial">
                            <div dangerouslySetInnerHTML={{ __html: this.renderPreheader }} />
                        </div>
                    }
                </React.Fragment>
            }
            {this.props.article &&
                <div className="activity-list__item__article article article--no-initial">
                    <div dangerouslySetInnerHTML={{ __html: this.props.article }} />
                </div>
            }
            {this.props.tags &&
                <div className="activity-list__item__tags">
                    <Tags alwaysVisible={true} useOverflow={true}>
                        {this.props.tags}
                    </Tags>
                </div>
            }
            {this.props.information &&
                <div className="activity-list__item__information">
                    {this.props.information}
                </div>
            }
        </li>;
    }

    private get getItemContent() {
        return <React.Fragment>
            {this.props.startTime ? this.renderTime : this.renderImage}
            <div className="activity-list__item__body">
                {this.props.children}
            </div>
            {this.props.hasArrow ? <div className="button arrow__wrapper"><Arrow modifierClass="arrow--colored" /></div> : null}
        </React.Fragment>
    }

    private get renderTime() {
        const startTime = dayjs(this.props.startTime);

        return <div className="activity-list__item__date">
            <span className="activity-list__item__date__inner">{startTime.format('D')} <div>{startTime.format('MMM').replace('.','')}</div><div>{startTime.format('YYYY')}</div></span>
        </div>;
    }

    private get renderImage() {
        return <div className="activity-list__item__image">
            {this.props.imageUrl ?
                <div style={{ backgroundImage: `url(${this.props.imageUrl})` }} />
                :
                <Icon name="person" />
            }
        </div>
    }

    private get renderPreheader() {
        const removeMarkup = /(<([^>]+)>)/ig;
        const preheader = this.props.preheader!.replace(removeMarkup, ' ');

        return preheader.length > 100 ? `${preheader.substring(0, 100)}&hellip;` : preheader
    }
}

export default ActivityListItem;